import { spacing, styled, Text } from '@thg-commerce/gravity-theme'

export const StoreStatusWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  gap: ${spacing(1)};
  align-items: center;
`
export const StyledText = styled.p`
  ${Text('bodyText', 'alternate')}
`
